<template>
    <div>
        <el-form :model="landSearchFilter" ref="projectForm" :rules="rules" label-position="left"
            class="employer-ruleForm">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="投资日期" prop="contractTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" size="large" v-model="landSearchFilter.contractTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.endDate" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="约定支付时间" prop="payTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.payTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.payTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="约定交地时间" prop="deliveryTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.deliveryTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.deliveryTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="约定开工时间" prop="startTime1" :label-width="labelWidth">
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.startTime1" type="date"
                            placeholder="选择开始时间"></el-date-picker> -
                        <el-date-picker format="yyyy-MM-dd"  value-format="yyyy-MM-dd" v-model="landSearchFilter.startTime2" type="date"
                            placeholder="选择结束时间"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="行政区域" prop="area" :label-width="labelWidth">
                        <el-select class="seletc-size-input" v-model="landSearchFilter.province" placeholder="请选择"
                            @change="onProvinceChange('area', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId"
                                :value="item.areaId" :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.city" placeholder="请选择"
                            @change="onCityChange('area', $event)" :disabled="landSearchFilter.province==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select v-show="!landSearchFilter.isCountyList" class="seletc-size-input" v-model="landSearchFilter.county" placeholder="请选择"
                            @change="onCountyChange('area', $event)" :disabled="landSearchFilter.city==''">
                             <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.area.countyList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select  class="seletc-size-input" v-model="landSearchFilter.countyListTemp" 
                            v-show="landSearchFilter.isCountyList"
                            multiple
                            filterable
                            allow-create
                            default-first-option
                            @change="countyListChange($event)"
                            placeholder="">
                            <!-- <el-option value="" label="全部"></el-option> -->
                            <el-option
                            v-for="item in lists.area.countyList"
                            :key="item.areaId"
                            :label="item.areaName"
                            :value="item.areaId">
                            </el-option>
                        </el-select>
                       <el-checkbox v-model="landSearchFilter.isCountyList">多个区县</el-checkbox>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资来源地" prop="sourceProvince" :label-width="labelWidth">
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceProvince"
                            placeholder="请选择" @change="onProvinceChange('source', $event)">
                            <el-option value="" label="全部"></el-option>
                            <el-option value="998" label="省外"></el-option>
                            <el-option value="997" label="市外"></el-option>
                            <el-option v-for="(item) in provinceList" :key="item.areaId" :value="item.areaId"
                                :label="item.areaName"></el-option>·
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceCity" placeholder="请选择"
                            @change="onCityChange('source', $event)" :disabled="landSearchFilter.sourceProvince==''">
                             <el-option value="" label="全部" v-show="landSearchFilter.sourceProvince!= '998'|| landSearchFilter.sourceProvince!= '997'"></el-option>
                            <el-option v-for="(item, index) in lists.source.cityList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.sourceCounty" placeholder="请选择"
                            @change="onCountyChange('source', $event)" :disabled="landSearchFilter.sourceCity==''">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in lists.source.countyList" :key="index" :value="item.areaId"
                                :label="item.areaName"></el-option>
                        </el-select>
                        <el-checkbox v-model="landSearchFilter.sourceExclude">剔除本省数据</el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="行业分类" prop="notionCode1" :label-width="labelWidth">
                        <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.industry1" placeholder="请选择" @change="industryChage('1', $event)">
                            <el-option v-for="(item, index) in notionList1" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.industry2" placeholder="请选择">
                            <el-option v-for="(item, index) in notionList2" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select>
                        <el-select class="seletc-size-input" v-model="landSearchFilter.industry3" placeholder="请选择">
                            <el-option v-for="(item, index) in notionList3" :key="index" :value="item.paraValue"
                                :label="item.paraName"></el-option>
                        </el-select> -->

                        <!-- 修改：el-option 的 value 改为整个 item，方便获取完整对象；并保留第一个 select 的 @change -->
                            <el-select class="seletc-size-input-2" v-model="landSearchFilter.industry1" placeholder="请选择"
                                @change="changeClass(1,$event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in notionClassList1" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第二个 select 添加 @change，并把 :value 改为 item -->
                            <el-select class="seletc-size-input-2" v-model="landSearchFilter.industry2" placeholder="请选择" 
                                @change="changeClass(2, $event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in notionClassList2" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                            <!-- 修改：为第三个 select 添加 @change，并把 :value 改为 item -->
                            <!-- <el-select class="seletc-size-input" v-model="landSearchFilter.industry3" placeholder="请选择" 
                                @change="changeClass(3, $event)">
                                <el-option value="" label="全部"></el-option>
                                <el-option v-for="item in notionClassList3" :key="item.value" :label="item.name"
                                    :value="item.value">
                                </el-option>
                            </el-select> -->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="土地性质" prop="landType1" :label-width="labelWidth">
                        <el-select v-model="landSearchFilter.landType1" placeholder="请选择" @change="landTypeChange">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in landTypeList" :key="index" :value="item.value"
                                :label="item.name"></el-option>
                        </el-select>
                        <el-select v-model="landSearchFilter.landType2" placeholder="请选择">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in landTypeList2" :key="index" :value="item.value"
                                :label="item.name"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="总面积" prop="size1" :label-width="labelWidth">
                        <el-input class="num-size-input" v-model="landSearchFilter.size1" placeholder=""></el-input>
                        -
                        <el-input class="num-size-input" v-model="landSearchFilter.size2" placeholder=""></el-input>
                        （亩）
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="成交价格" prop="price1" :label-width="labelWidth">
                        <el-input class="num-size-input" v-model="landSearchFilter.price1" placeholder=""></el-input>
                        -
                        <el-input class="num-size-input" v-model="landSearchFilter.price2" placeholder=""></el-input>
                        （万元）
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="容积率" prop="volume1" :label-width="labelWidth">
                        <el-input class="num-size-input" v-model="landSearchFilter.volume1"
                            placeholder=""></el-input>
                        -
                        <el-input class="num-size-input" v-model="landSearchFilter.volume2"
                            placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="使用年限" prop="useYears" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.useYears" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="供地方式" prop="supplyMode1" :label-width="labelWidth">
                        <el-select class="seletc-size-input-1"  v-model="landSearchFilter.supplyMode1" @change="changeSupplyMode(1,$event)" placeholder="请选择">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in bigLandUseList" :key="index" :value="item.value"
                                :label="item.name"></el-option>
                        </el-select>
                        <!-- <el-select v-model="landSearchFilter.supplyMode2" placeholder="请选择">
                            <el-option v-for="(item, index) in smallLandUseList" :key="index" :value="item.value"
                                :label="item.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="土地级别" prop="landLevel" :label-width="labelWidth">
                        <el-select class="seletc-size-input-1"  v-model="landSearchFilter.landLevel" @change="changeSupplyMode(1,$event)" placeholder="请选择">
                            <el-option value="" label="全部"></el-option>
                            <el-option v-for="(item, index) in landLevelList" :key="index" :value="item.value"
                                :label="item.name"></el-option>
                        </el-select>
                        <!-- <el-input class="text-input" v-model="landSearchFilter.landLevel" placeholder=""></el-input> -->
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目名称" prop="projectName" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.projectName" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="项目位置" prop="location" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.location"
                            placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="使用权人" prop="owner" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.owner" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资主体" prop="investor" :label-width="labelWidth">
                        <el-input class="text-input" v-model="landSearchFilter.investor" placeholder=""></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="btn oh mr-8 mb-2">
            <div class="fr">
                <el-button icon="el-icon-search" type="primary" @click="search">查询</el-button>
                <el-button icon="el-icon-refresh-left" @click="reset">重置</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import { dataInJs } from "@/utils/city.js";
export default {
    name: 'landFilterCom',
    data() {
        return {
            labelWidth: '120px',
            rules: {},
            provincedata: dataInJs(),
            landSearchFilter: {
                isCountyList: false,
                contractTime1: '',
                contractTime2: '',
                payTime1: '',
                payTime2: '',
                deliveryTime1: '',
                deliveryTime2: '',
                startTime1: '',
                startTime2: '',
                province: '',
                city: '',
                county: '',
                countyList:'',
                countyListTemp: [],
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                industry1: '',
                industry2: '',
                industry3: '',
                landType1: '',
                landType2: '',
                size1: '',
                size2: '',
                price1: '',
                price2: '',
                volume1: '',
                volume2: '',
                useYears: '',
                supplyMode1: '',
                supplyMode2: '',
                landLevel: '',
                projectName: '',
                location: '',
                owner: '',
                investor: '',
                sourceExclude: 0,

            },
            provinceList: dataInJs(),
            lists: {
                area: {
                    cityList: [],
                    countyList: []
                },
                source: {
                    cityList: [],
                    countyList: []
                }
            },
            cityList: [],
            countyList: [],
            bigLandUseList: [],
            smallLandUseList: [],
            notionClassList1: [],
            notionClassList2: [],
            notionClassList3: [],
            landTypeList: [],
            landTypeList2: [],
            landLevelList: [],
        }
    },
    created() {
    },
    mounted() {
        this.getLandUse();
        this.getsupplyMode();
        this.getIndustryList();
        this.getLandLevel();
    },
    methods: {
        //获取土地级别
        getLandLevel() {
            this.$axios.get(this.$api.metall.LandParam.landLevel()).then((res) => {
                if (res.data.success) {
                    this.landLevelList = res.data.list;
                } else {
                    this.$message.error(res.data.message);
                }
                
            })
        },
        //供地方式联动
        changeSupplyMode(step, value) { 
            // console.log('changeSupplyMode', step, value);
            if (step == 1) { 
                this.smallLandUseList = [];
                this.bigLandUseList.forEach(item => {
                    if (item.value == value) {
                        this.smallLandUseList = item.children || [];
                    }
                })
            }
        },
        //获取供地方式
        getsupplyMode() {
            this.$axios.get(this.$api.metall.LandParam.supplyMode()).then((res) => {
                if (res.data.success) {
                    this.bigLandUseList = res.data.list;
                } else {
                    this.$message.error(res.data.message);
                }
                
            })
        },
        //获取行业分类
        getIndustryList() { 
            this.$axios.get(this.$api.metall.LandParam.landIndustry()).then((res) => {
               if (res.data.success) { 
                console.log('行业分类',res);
                this.notionClassList1 = res.data.list;
               } else {
                   this.$message.error(res.data.message);
               }
           })
        },
        //行业分类联动
        changeClass(step, value) {
            console.log('changeClass', step, value, this.notionClassList1);
            if (!value) {
                return;
            } 
             if (step == 1) { 
                this.notionClassList2 = this.notionClassList1.find(item => item.value == value).children || [];
                this.notionClassList3 = [];
                this.landSearchFilter.industry2 = '';
                this.landSearchFilter.industry3 = '';
                console.log('notionClassList2', this.notionClassList2);

            }else if (step == 2) {
                this.notionClassList3 = this.notionClassList2.find(item => item.value == value).children || [];
                this.landSearchFilter.industry3 = '';
                console.log('notionClassList3', this.notionClassList3);
            }else if (step == 3) { 
                this.landSearchFilter.industry3 = value;
            }
        },
        //获取拿地性质
        getLandUse() {
            this.$axios.get(this.$api.metall.LandParam.landType()).then((res) => {
               if (res.data.success) { 
                this.landTypeList = res.data.list;
               } else {
                   this.$message.error(res.data.message);
               }
           })
        },
        landTypeChange(value) {
            console.log(value);
            this.landType1 = value;
            this.landType2 = '' ;
            this.landTypeList2 = this.landTypeList.find(item => item.value == value).children || [];
            console.log(this.landTypeList2);
        },
        countyListChange(value) {
            console.log(value);
            // return
            this.landSearchFilter.countyList = value.join(',');
            console.log(this.landSearchFilter.countyList);
        },
        onProvinceChange(target, value) {
            // 清理对应字段
            if (target === 'area') {
                this.landSearchFilter.province = value;
                this.landSearchFilter.city = '';
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceProvince = value;
                this.landSearchFilter.sourceCity = '';
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据省获取城市
            const selectedProvince = this.provinceList.find(item => item.areaId === value);
            if (selectedProvince && selectedProvince.children) {
                this.lists[target].cityList = selectedProvince.children;
            } else {
                this.lists[target].cityList = [];
            }
            // 清空县列表
            this.lists[target].countyList = [];
        },

        onCityChange(target, value) {
            // 清理对应县及设置 city
            if (target === 'area') {
                this.landSearchFilter.city = value;
                this.landSearchFilter.county = '';
            } else {
                this.landSearchFilter.sourceCity = value;
                this.landSearchFilter.sourceCounty = '';
            }

            // 根据 city 获取 county
            const selectedCity = this.lists[target].cityList.find(item => item.areaId === value);
            if (selectedCity && selectedCity.children) {
                this.lists[target].countyList = selectedCity.children;
            } else {
                this.lists[target].countyList = [];
            }
        },

        onCountyChange(target, value) {
           
            if (target === 'area') {
                 console.log('区县area', target, value);
                this.landSearchFilter.county = value;
            } else {
                 console.log('区县area', target, value);
                this.landSearchFilter.sourceCounty = value;
            }
        },
        search() {
            console.log(this.landSearchFilter);
            this.landSearchFilter.sourceExclude = this.landSearchFilter.sourceExclude ? 1 : 0;
            this.landSearchFilter.countyList = this.landSearchFilter.isCountyList ? this.landSearchFilter.countyList : '';
            this.$emit('search', this.landSearchFilter);
        },
        reset() {
            // 重置所有筛选项并清空两个目标的城市/区县列表
            this.landSearchFilter = {
                contractTime1: '',
                contractTime2: '',
                payTime1: '',
                payTime2: '',
                deliveryTime1: '',
                deliveryTime2: '',
                startTime1: '',
                startTime2: '',
                province: '',
                city: '',
                county: '',
                sourceProvince: '',
                sourceCity: '',
                sourceCounty: '',
                industry1: '',
                industry2: '',
                industry3: '',
                landType1: '',
                landType2: '',
                size1: '',
                size2: '',
                price1: '',
                price2: '',
                volume1: '',
                volume2: '',
                useYears: '',
                supplyMode1: '',
                supplyMode2: '',
                landLevel: '',
                projectName: '',
                location: '',
                owner: '',
                investor: '',
            }
            this.lists.area.cityList = [];
            this.lists.area.countyList = [];
            this.lists.source.cityList = [];
            this.lists.source.countyList = [];
        }
    }
}
</script>
<style scoped lang="scss">
::v-deep {
    .text-input {
        width: 70%
    }

    .el-input__inner {
        font-size: 14px;
        // line-height: 80px;
        height: 38px;
    }

    .el-form-item__label {
        font-weight: bold;
        font-size: 16px;
        color: #333;
    }

    .num-size-input {
        width: 228px;
    }

    .seletc-size-input {
        width: 140px;
    }
    .seletc-size-input-2 {
        width: 220px;
    }
    .seletc-size-input-1 {
        width: 470px;
    }
}
</style>